import { WidgetProps } from '@rjsf/utils';

export interface ReadOnlyTextWidgetProps extends WidgetProps {}

/**
 * Minimal read-only text widget that displays raw values.
 *
 * @param props.value - Value to display
 * @returns Raw value
 */
export function ReadOnlyTextWidget(props: ReadOnlyTextWidgetProps) {
  return props.value;
}
